import Api from '@/api/Api'

class Auth extends Api {
  public async register<T>(payload: RegisterPayload) {
    const { data, error, response } = await this.fetch('register').post(payload).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async authenticate<T>(credential: Credentials) {
    const { data, error, response } = await this.fetch('token').post(credential).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async authenticateSocial<T>(credential: SocialCredentials) {
    const { data, error, response } = await this.fetch('token/social').post(credential).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async me<T>() {
    const { data, error, response } = await this.fetch('me').json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new Auth()
